"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _antd = require("antd");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _locale = require("../locale");
var _meta = require("../meta");
var _makeStyle = _interopRequireDefault(require("../utils/makeStyle"));
var _TokenContent = _interopRequireDefault(require("./TokenContent"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyle = (0, _makeStyle.default)('TokenPanelPro', function (token) {
  return {
    '.token-panel-pro': {
      width: '100%',
      height: '100%',
      display: 'flex',
      borderInlineEnd: "1px solid ".concat(token.colorBorderSecondary),
      '.token-panel-pro-content': (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }, "".concat(token.rootCls, "-anchor-wrapper"), {
        padding: '0px 16px'
      }), "".concat(token.rootCls, "-anchor"), {
        padding: '10px 0'
      }), '.token-panel-pro-list', {
        overflow: 'auto'
      })
    }
  };
});
var TokenPanelPro = function TokenPanelPro(_ref) {
  var className = _ref.className,
    style = _ref.style,
    theme = _ref.theme,
    selectedTokens = _ref.selectedTokens,
    onTokenSelect = _ref.onTokenSelect,
    infoFollowPrimary = _ref.infoFollowPrimary,
    onInfoFollowPrimaryChange = _ref.onInfoFollowPrimaryChange;
  var _useStyle = useStyle(),
    _useStyle2 = (0, _slicedToArray2.default)(_useStyle, 2),
    wrapSSR = _useStyle2[0],
    hashId = _useStyle2[1];
  var _useState = (0, _react.useState)('brandColor'),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    activeGroup = _useState2[0],
    setActiveGroup = _useState2[1];
  var locale = (0, _locale.useLocale)();
  var activeCategory = (0, _react.useMemo)(function () {
    return _meta.tokenCategory.reduce(function (result, category) {
      return result !== null && result !== void 0 ? result : category.groups.find(function (group) {
        return group.key === activeGroup;
      });
    }, undefined);
  }, [activeGroup]);
  (0, _react.useEffect)(function () {
    var _activeCategory$seedT;
    onTokenSelect === null || onTokenSelect === void 0 || onTokenSelect((_activeCategory$seedT = activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.seedToken) !== null && _activeCategory$seedT !== void 0 ? _activeCategory$seedT : [], 'seed');
  }, [activeCategory]);
  var tokenListRef = (0, _react.useRef)(null);
  return wrapSSR( /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(hashId, className, 'token-panel-pro'),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "token-panel-pro-content"
  }, /*#__PURE__*/_react.default.createElement(_antd.Anchor, {
    affix: false,
    direction: "horizontal",
    getContainer: function getContainer() {
      return tokenListRef.current;
    },
    onChange: function onChange(key) {
      var _tokenCategory$find$g, _tokenCategory$find;
      setActiveGroup((_tokenCategory$find$g = (_tokenCategory$find = _meta.tokenCategory.find(function (category) {
        return category.nameEn === key;
      })) === null || _tokenCategory$find === void 0 ? void 0 : _tokenCategory$find.groups[0].key) !== null && _tokenCategory$find$g !== void 0 ? _tokenCategory$find$g : '');
    },
    items: _meta.tokenCategory.map(function (category) {
      return {
        key: category.nameEn,
        title: locale._lang === 'zh-CN' ? category.name : category.nameEn,
        href: "#".concat(category.nameEn)
      };
    })
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "token-panel-pro-list",
    ref: tokenListRef
  }, _meta.tokenCategory.map(function (category) {
    return /*#__PURE__*/_react.default.createElement(_TokenContent.default, {
      id: category.nameEn,
      key: category.nameEn,
      category: category,
      theme: theme,
      selectedTokens: selectedTokens,
      onTokenSelect: onTokenSelect,
      infoFollowPrimary: infoFollowPrimary,
      onInfoFollowPrimaryChange: onInfoFollowPrimaryChange,
      activeGroup: activeGroup,
      onActiveGroupChange: setActiveGroup
    });
  })))));
};
var _default = exports.default = TokenPanelPro;